// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.technics-laterality-form {}
.technics-laterality-form__form {}
.technics-laterality-form__form__contect{
    margin: var(--space-x2);
}
.technics-laterality-form__form__fields {
    padding: var(--space);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: var(--space-and-half);
    width: calc(var(--space-x3) * 8);
    margin: auto;
}
.technics-laterality-form__form__fields__laterality {
    padding: 12px 37px;
    background: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
    box-sizing: border-box;
}
.technics-laterality-form__form__fields__laterality:hover {
    background: var(--new-green-color);
    cursor: pointer;
}
.technics-laterality-form__form__fields__laterality.active {
    background: var(--new-green-color);
}
/* .technics-laterality-form__form__fields__laterality__img {
    
} */
.technics-laterality-form__form__fields__laterality__img img {
    width: 100%;
    border-radius: 8px;
}
.technics-laterality-form__form__fields__laterality__caption.baloa-username{
    margin-top: var(--space);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: var(--font-bold);
    color: var(--primary-very-dark-color);
}

.active .technics-laterality-form__form__fields__laterality__caption.baloa-username,
.technics-laterality-form__form__fields__laterality:hover .technics-laterality-form__form__fields__laterality__caption.baloa-username{
    color: var(--white-color);
}

.technics-laterality-form__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid var(--new-input-background-color);
}
.modal2.technics-laterality .modal2__container{
    width: 30%;
}

.technics-laterality-form__subtitle.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    margin: 24px 0 0 40px;
}

@media screen and (max-width: 1100px){
    .modal2.technics-laterality .modal2__container{
        width: 50%;
    }
}

@media screen and (max-width: 650px){
    .modal2.technics-laterality .modal2__container{
        width: 70%;
    }
}

@media screen and (max-width: 440px){
    .modal2.technics-laterality .modal2__container{
        width: 100%;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .modal2.technics-laterality .modal2__container{
        width: 100%;
        margin: 0;
        border-radius: 0;
        height: 100vh;
        max-height: 100%;
    }
    
    .technics-laterality .modal2__header__title{
        margin: 12px 0;
        padding: 0;
    }

    .technics-laterality-form__form__actions{
        position: fixed;
        bottom: 0;
    }

    .technics-laterality-form__form__contect{
        height: 100vh;
        margin: var(--space);
    }

    .technics-laterality-form__form__fields{
        width: 100%;
        padding: 0;
    }

    button.button.primary-button.technics-form__form__submit{
        width: 100%;
    }

    .technics-laterality-form__subtitle.baloa-subtitle-2{
        margin: 24px 0 0 12px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-technics-laterality-modal/ProfileTechnicsLateralityModalComponent.styles.css"],"names":[],"mappings":";AACA,2BAA2B;AAC3B,iCAAiC;AACjC;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,oDAAoD;IACpD,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,kCAAkC;IAClC,eAAe;AACnB;AACA;IACI,kCAAkC;AACtC;AACA;;GAEG;AACH;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,uDAAuD;AAC3D;AACA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,aAAa;QACb,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":["\n.technics-laterality-form {}\n.technics-laterality-form__form {}\n.technics-laterality-form__form__contect{\n    margin: var(--space-x2);\n}\n.technics-laterality-form__form__fields {\n    padding: var(--space);\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: var(--space-and-half);\n    width: calc(var(--space-x3) * 8);\n    margin: auto;\n}\n.technics-laterality-form__form__fields__laterality {\n    padding: 12px 37px;\n    background: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    box-sizing: border-box;\n}\n.technics-laterality-form__form__fields__laterality:hover {\n    background: var(--new-green-color);\n    cursor: pointer;\n}\n.technics-laterality-form__form__fields__laterality.active {\n    background: var(--new-green-color);\n}\n/* .technics-laterality-form__form__fields__laterality__img {\n    \n} */\n.technics-laterality-form__form__fields__laterality__img img {\n    width: 100%;\n    border-radius: 8px;\n}\n.technics-laterality-form__form__fields__laterality__caption.baloa-username{\n    margin-top: var(--space);\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-weight: var(--font-bold);\n    color: var(--primary-very-dark-color);\n}\n\n.active .technics-laterality-form__form__fields__laterality__caption.baloa-username,\n.technics-laterality-form__form__fields__laterality:hover .technics-laterality-form__form__fields__laterality__caption.baloa-username{\n    color: var(--white-color);\n}\n\n.technics-laterality-form__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    border-top: 1px solid var(--new-input-background-color);\n}\n.modal2.technics-laterality .modal2__container{\n    width: 30%;\n}\n\n.technics-laterality-form__subtitle.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    margin: 24px 0 0 40px;\n}\n\n@media screen and (max-width: 1100px){\n    .modal2.technics-laterality .modal2__container{\n        width: 50%;\n    }\n}\n\n@media screen and (max-width: 650px){\n    .modal2.technics-laterality .modal2__container{\n        width: 70%;\n    }\n}\n\n@media screen and (max-width: 440px){\n    .modal2.technics-laterality .modal2__container{\n        width: 100%;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .modal2.technics-laterality .modal2__container{\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        height: 100vh;\n        max-height: 100%;\n    }\n    \n    .technics-laterality .modal2__header__title{\n        margin: 12px 0;\n        padding: 0;\n    }\n\n    .technics-laterality-form__form__actions{\n        position: fixed;\n        bottom: 0;\n    }\n\n    .technics-laterality-form__form__contect{\n        height: 100vh;\n        margin: var(--space);\n    }\n\n    .technics-laterality-form__form__fields{\n        width: 100%;\n        padding: 0;\n    }\n\n    button.button.primary-button.technics-form__form__submit{\n        width: 100%;\n    }\n\n    .technics-laterality-form__subtitle.baloa-subtitle-2{\n        margin: 24px 0 0 12px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
